// extracted by mini-css-extract-plugin
module.exports = {"noteHighlight":"video-control_noteHighlight__2M1vV"};